import { OtoIndividualTransferMethodEnum } from '../../lib/types/enums/enrollment/oto-individual-transfer-method.enum'
import { PropositionPricingInput } from '../../lib/types/models/enrollment-proposition/proposition-pricing'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'
import { EnrollmentPropositionSummaryType } from './get-enrollment-proposition-summary'

// what changes the price of an OTO Individual selection — every amount is resolved by the backend
export type OtoIndividualPropositionPricingRequest = {
  numberOfWeeks: number
  // the age limits are read on the departure date of the stay
  departureDate: string
  regionOfStayId: number
  optionId?: number
  transferMethod: OtoIndividualTransferMethodEnum
  pricing?: PropositionPricingInput
  promoCode?: string
  insuranceIds?: number[]
  // the age limits of the région de séjour and of its lieu d'arrivée are resolved against it,
  // so the backend prices a mandatory option / accueil-transfert whatever was sent
  childBirthDate?: string
}

// the OTO Individual pricing also reports which parts the age limits made mandatory, and the
// transfer method it actually priced
export type OtoIndividualPropositionPricing = EnrollmentPropositionSummaryType & {
  optionIsMandatory?: boolean
  transferIsMandatory?: boolean
  transferMethod?: OtoIndividualTransferMethodEnum
}

export const getOtoIndividualPropositionPricing = async (
  data: OtoIndividualPropositionPricingRequest
): Promise<OtoIndividualPropositionPricing> => {
  return restApiClient
    .url(constructApiUrl(API.enrollments.getOtoIndividualPropositionPricing.url, null))
    .post<OtoIndividualPropositionPricing, OtoIndividualPropositionPricingRequest>(data)
}

export const getOtoIndividualPropositionPricingById = async (
  enrollmentId: number
): Promise<OtoIndividualPropositionPricing> => {
  return restApiClient
    .url(
      constructApiUrl(API.enrollments.getOtoIndividualPropositionPricingById.url, {
        id: enrollmentId
      })
    )
    .get<OtoIndividualPropositionPricing>()
}
